<template>
  <!-- 碎片活动管理-添加碎片分区 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加会员卡' : '编辑会员卡'"
      width="400px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="name" label="会员卡名称">
          <el-input placeholder="请输入名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="amount" label="面值">
          <el-input placeholder="请输入面值" v-model="dataForm.amount">
          </el-input>
        </el-form-item>
        <el-form-item prop="frequency" label="发币频率">
          <el-input
            placeholder="请输入时间"
            v-model="dataForm.frequency"
            style="width: 100px; margin-right: 5px"
          >
          </el-input>
          <el-select
            v-model="dataForm.frequency_unit"
            placeholder="请选择单位"
            style="width: 120px"
          >
            <el-option :value="1" label="小时"></el-option>
            <el-option :value="2" label="日"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="time2" label="失效时间">
          <el-input
            placeholder="请输入时间"
            v-model="dataForm.overdue"
            style="width: 100px; margin-right: 5px"
          >
          </el-input>
          <el-select
            v-model="dataForm.overdue_unit"
            placeholder="请选择单位"
            style="width: 120px"
          >
            <el-option :value="1" label="小时"></el-option>
            <el-option :value="2" label="日"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select v-model="dataForm.status" placeholder="请选择状态">
            <el-option :value="1" label="生效中"></el-option>
            <el-option :value="2" label="关闭"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '../../utils/cookie'
import saveFile from '@/utils/saveFile'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      imgType: 'prize',//上传图片的种类 奖品
      dataForm: {
        name: '',
        amount: '',
        frequency: '',
        frequency_unit: '',
        overdue: '',
        overdue_unit: '',
        status: 2,//默认关闭
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      } else {
        this.dataForm = {
          name: '',
          amount: '',
          frequency: '',
          frequency_unit: '',
          overdue: '',
          overdue_unit: '',
          status: 2,//默认关闭
        }
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      // this.dataForm.room = id
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('member_card', params).then(res => {
          this.$message.success("添加成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`member_card/${this.dataForm.id}`, params).then(res => {
          this.$message.success("编辑成功")
          this.$emit('refresh')
          this.closeDialog()
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>